import React from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import './pageNotFound.scss';

const PageNotFound = () => {
  const { pathname } = useLocation();
  const isMissingProduct = /^\/products\/[^/]+$/.test(pathname);
  const heading = isMissingProduct
    ? 'This piece is no longer available.'
    : 'This page is unavailable.';
  const description = isMissingProduct
    ? 'It may have been removed or moved from the collection.'
    : 'The link may be outdated or the page may have moved.';

  return (
    <section className="page-not-found" aria-labelledby="page-not-found-title">
      <header className="page-not-found__intro">
        <span className="page-not-found__code">404</span>
        <p className="page-not-found__eyebrow">
          {isMissingProduct ? 'Product unavailable' : 'Page not found'}
        </p>
        <h1 id="page-not-found-title">{heading}</h1>
        <p className="page-not-found__description">{description}</p>
        <Link className="page-not-found__home" to="/">
          <HomeOutlined aria-hidden="true" /> Go to home
        </Link>
      </header>

    </section>
  );
};

export default PageNotFound;
